import styled from "@emotion/styled";
import { useHead } from "@unhead/react";

import { SEOHead } from "@/components/helpers/seo/SEOHead";
import { PublicFooter } from "@/components/nav/PublicFooter";
import { PublicNav } from "@/components/nav/PublicNav";
import { BrandsV2 } from "@/components/pieces/marketing/BrandsV2";
import { OPACITY_TRANSITION, SITE_NAME } from "@/css/constants";

import { MainHero } from "./MainHero";

export function Demo() {
  useHead({
    bodyAttrs: { class: "public-site" },
  });

  return (
    <>
      <SEOHead
        title={`Book a Demo - ${SITE_NAME}`}
        description="Experience what Exec can do for your team. Schedule a demo today."
        canonicalPath="/about-us"
        image="https://placement-pub.s3.us-east-2.amazonaws.com/about-meta.jpg"
      />
      <PublicNav />
      <StyledContainer className="content-page">
        <MainHero />
        <BrandsV2 opacity={1} backgroundColor="#FFF" />
      </StyledContainer>
      <PublicFooter />
    </>
  );
}

const StyledContainer = styled.div`
  transition: ${OPACITY_TRANSITION};
  .story-title {
    font-size: 30px;
    font-weight: 300;
    margin-top: 0;
    margin-bottom: 8px;
    line-height: 1.42;
  }
  .story-img-container {
    position: relative;
    .story-img-background {
      position: absolute;
      z-index: -5;
      bottom: -45px;
      left: 0;
      right: 0;
    }
  }
  .investors-container {
    background-color: #f5f8ff;
  }
  .placement-office {
    width: 100%;
    border-radius: 8px;
  }
`;
